import ActionTypes from "../constants";
import * as api from '../api/index';
// import Swal from 'sweetalert2';
// import Router from "next/router";
import Toast from "../components/Toast"

export const getInsuranceStatement = (filter) => async (dispatch) => {
    // alert('Login Auth Action');
    dispatch({
        type: ActionTypes.LOADING,
        payload: true,
    });
    const response = await api.getInsuranceStatement(filter).then(res => {
        // 
        if (JSON.parse(res).status == 200) {
            // res.status);
            dispatch({
                type: ActionTypes.GETINSURANCESTATEMENTSUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.GETINSURANCESTATEMENTFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        
        dispatch({
            type: ActionTypes.GETINSURANCESTATEMENTFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}
//Investigation Schedule
export const getInvestigationSchedule = (filter) => async (dispatch) => {
    // console.log('here', filter);
    dispatch({
        type: ActionTypes.LOADING,
        payload: true,
    });
    const response = await api.getInvestigationSchedule(filter).then(res => {
        if (JSON.parse(res).status == 200) {
            dispatch({
                type: ActionTypes.GETINVESTIGATIONSCHEDULESUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
        }
        else {
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.GETINVESTIGATIONSCHEDULEFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        
        dispatch({
            type: ActionTypes.GETINVESTIGATIONSCHEDULEFAILED,
            payload: err,
        });
    })
}
//Estimate Schedule
export const getEstimateSchedule = (filter) => async (dispatch) => {
    // console.log('here', filter);
    dispatch({
        type: ActionTypes.LOADING,
        payload: true,
    });
    const response = await api.getEstimateSchedule(filter).then(res => {
        if (JSON.parse(res).status == 200) {
            dispatch({
                type: ActionTypes.GETESTIMATESCHEDULESUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
        }
        else {
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.GETESTIMATESCHEDULEFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        
        dispatch({
            type: ActionTypes.GETESTIMATESCHEDULEFAILED,
            payload: err,
        });
    })
}
//Price Statement
export const getPriceStatement = (filter) => async (dispatch) => {
    console.log('here', filter);
    dispatch({
        type: ActionTypes.LOADING,
        payload: true,
    });
    const response = await api.getPriceStatement(filter).then(res => {
        if (JSON.parse(res).status == 200) {
            dispatch({
                type: ActionTypes.GETPRICESTATEMENTSUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
        }
        else {
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.GETPRICESTATEMENTFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        
        dispatch({
            type: ActionTypes.GETPRICESTATEMENTFAILED,
            payload: err,
        });
    })
}
//Job Card Schedule
export const getJobCardSchedule = (filter) => async (dispatch) => {
    console.log('here', filter);
    dispatch({
        type: ActionTypes.LOADING,
        payload: true,
    });
    const response = await api.getJobCardSchedule(filter).then(res => {
        if (JSON.parse(res).status == 200) {
            dispatch({
                type: ActionTypes.GETJOBCARDSCHEDULESUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
        }
        else {
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.GETJOBCARDSCHEDULEFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        
        dispatch({
            type: ActionTypes.GETJOBCARDSCHEDULEFAILED,
            payload: err,
        });
    })
}
//Cost Statement
export const getCostStatement = (filter) => async (dispatch) => {
    // console.log('here', filter);
    dispatch({
        type: ActionTypes.LOADING,
        payload: true,
    });
    const response = await api.getCostStatement(filter).then(res => {
        if (JSON.parse(res).status == 200) {
            dispatch({
                type: ActionTypes.GETCOSTSTATEMENTSUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
        }
        else {
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.GETCOSTSTATEMENTFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        
        dispatch({
            type: ActionTypes.GETCOSTSTATEMENTFAILED,
            payload: err,
        });
    })
}
//Statement Meethaq Takaful Insurance
export const getStatementMeethaqTakafulInsurance = (filter) => async (dispatch) => {
    console.log('here', filter);
    dispatch({
        type: ActionTypes.LOADING,
        payload: true,
    });
    const response = await api.getStatementMeethaqTakafulInsurance(filter).then(res => {
        if (JSON.parse(res).status == 200) {
            dispatch({
                type: ActionTypes.GETSTATEMENTMEETHAQTAKAFULINSURANCESUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
        }
        else {
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.GETSTATEMENTMEETHAQTAKAFULINSURANCEFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        
        dispatch({
            type: ActionTypes.GETSTATEMENTMEETHAQTAKAFULINSURANCEFAILED,
            payload: err,
        });
    })
}
